import { render } from "./Index.vue?vue&type=template&id=ac9e4a0e"
import script from "./Index.vue?vue&type=script&lang=js"
export * from "./Index.vue?vue&type=script&lang=js"

import exportComponent from "/Users/herianto/Projects/yeu-logistik/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/Pages/Packages/Index.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "ac9e4a0e"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('ac9e4a0e', __exports__)) {
    console.log('reload')
    api.reload('ac9e4a0e', __exports__)
  }
  
  module.hot.accept("./Index.vue?vue&type=template&id=ac9e4a0e", () => {
    console.log('re-render')
    api.rerender('ac9e4a0e', render)
  })

}


export default __exports__